import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ComponentSync } from '../../core/ComponentSync.js';
import { TS_Icons } from '@nu-art/ts-styles';
export class DBItemDropDownMultiSelector extends ComponentSync {
    static selector = (uiSelector) => {
        return (selector) => _jsx(DBItemDropDownMultiSelector, { selector: selector, uiSelector: uiSelector, queryFilter: selector.queryFilter });
    };
    static propsV3 = (props) => {
        return {
            itemRenderer: (itemId, onDelete, disabled) => {
                const dbItem = props.module.cache.unique(itemId);
                return props.itemRenderer(dbItem, onDelete, disabled);
            },
            selectionRenderer: DBItemDropDownMultiSelector.selector(props.uiSelector),
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            selectionFilter: (item) => true,
        };
    };
    render() {
        const UISelector = this.props.uiSelector;
        const selector = this.props.selector;
        const filter = (item) => {
            return !selector.existingItems.includes(item._id)
                && (this.props.queryFilter ? this.props.queryFilter(item._id) : true);
        };
        return _jsx(UISelector, { queryFilter: filter, onSelected: item => selector.onSelected(item._id) });
    }
    deriveStateFromProps(nextProps, state) {
        return { onSelected: nextProps.selector.onSelected };
    }
}
export class DBItemDropDownMultiSelector_DBPointer extends ComponentSync {
    static selector = (uiSelector) => {
        return (selector) => _jsx(DBItemDropDownMultiSelector_DBPointer, { selector: selector, uiSelector: uiSelector, queryFilter: selector.queryFilter });
    };
    static defaultItemRenderer = (onDelete, disabled) => {
        return _jsxs(_Fragment, { children: [!disabled && _jsx(TS_Icons.x.component, { onClick: onDelete }), 'N/A'] });
    };
    static props = (props) => {
        return {
            itemRenderer: (item, onDelete, disabled) => {
                if (!item)
                    return DBItemDropDownMultiSelector_DBPointer.defaultItemRenderer(onDelete, disabled);
                const itemRenderer = props.pointerProps[item.dbKey].renderer;
                return itemRenderer(item, onDelete, disabled);
            },
            selectionRenderer: DBItemDropDownMultiSelector_DBPointer.selector(props.uiSelector),
            selectionFilter: (item) => true,
        };
    };
    render() {
        const UISelector = this.props.uiSelector;
        const selector = this.props.selector;
        const filter = (item) => {
            const existing = selector.existingItems.find(existing => existing.id === item.item._id);
            return !existing && (this.props.queryFilter ? this.props.queryFilter(item.item._id) : true);
        };
        return _jsx(UISelector, { queryFilter: filter, onSelected: item => selector.onSelected({ dbKey: item.dbKey, id: item.item._id }) });
    }
    deriveStateFromProps(nextProps, state) {
        return { onSelected: nextProps.selector.onSelected };
    }
}
//# sourceMappingURL=DBItemDropDownMultiSelector.js.map